module.exports = __webpack_public_path__ + "static/media/loc3_img7.27248af6.jpg";